const {
  callAuthorizedGraphQLEndpoint,
} = require('../../../../../Module/graphQL')

export const deleteClientCodes = queryVars => {
  return callAuthorizedGraphQLEndpoint(
    `mutation ($input: DeleteCampaignClientCodes!) {
      deleteClientCodes(input:$input){
        campaignId
        clientCodes{
          id
          clientCode
          clientLink
          city{
            id
            name
          }
        }
      }
    }`,
    {
      input: queryVars,
    },
  )
}
